import { SVGIconComponent } from './types';

export const ActionUndoCancel: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="26px"
    height="26px"
    viewBox="0 0 26 26"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g id="Action/UnCancel" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M13,5 C17.96395,5 22,9.0360725 22,14 C22,18.964775 17.9638,23 13,23 C8.03617,23 4,18.964775 4,14 C4,9.0360725 8.0360725,5 13,5 Z M13,6.5 C8.8645,6.5 5.5,9.8645 5.5,14 C5.5,18.13625 8.8645,21.5 13,21.5 C17.1355,21.5 20.5,18.13625 20.5,14 C20.5,9.8645 17.1355,6.5 13,6.5 Z M13,10.25 C13.414225,10.25 13.75,10.58579 13.75,11 L13.75,13.25 L16,13.25 C16.414225,13.25 16.75,13.585775 16.75,14 C16.75,14.414225 16.414225,14.75 16,14.75 L13.75,14.75 L13.75,17 C13.75,17.414225 13.414225,17.75 13,17.75 C12.585775,17.75 12.25,17.414225 12.25,17 L12.25,14.75 L10,14.75 C9.58579,14.75 9.25,14.414225 9.25,14 C9.25,13.585775 9.58579,13.25 10,13.25 L12.25,13.25 L12.25,11 C12.25,10.58579 12.585775,10.25 13,10.25 Z"
        id="Combined-Shape"
        fill="#848484"
        transform="translate(13.000000, 14.000000) rotate(45.000000) translate(-13.000000, -14.000000) "
      ></path>
      <path
        d="M5.07554129,0.230420453 L6.70626504,1.91184164 L5.31631231,3.34500649 L8.25021483,3.34500649 C9.37882641,3.34500649 10.4622194,3.80593359 11.2602194,4.62945592 C12.0535545,5.44674664 12.5,6.55533054 12.5,7.71141085 L12.5,7.71141085 L12.4998482,9.5 L10.2499727,9.5 L10.2499727,7.71122343 C10.2499727,7.15871947 10.037776,6.62794541 9.65864683,6.2369644 C9.28518574,5.85182863 8.77878801,5.63375084 8.25021483,5.63375084 L8.25021483,5.63375084 L5.31631231,5.63375084 L6.70626504,7.0669157 L5.12535052,8.69697914 L1.52837502,4.98738964 L5.07554129,0.230420453 Z"
        id="Path"
        stroke="#FFFFFF"
        fill="#848484"
        fillRule="nonzero"
      ></path>
    </g>
  </svg>
);
